module.exports = __webpack_public_path__ + "img/exchangeLimits1x.21d3f027.png";